import { type PropsWithChildren } from 'react';

import { maxValue } from './Max.sty.js';
import type { ComponentWithName } from '../../../../../../core/types/component-with-name.js';

export const Max = ({ children }: PropsWithChildren) =>
  children !== undefined ? <p className={maxValue}>{children}</p> : null;

(Max as ComponentWithName<typeof Max>).displayName = 'MeterBarLayout.Max';
